import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthorizerService } from '@markant-platform/authorizer/data-access';
import { firstValueFrom } from 'rxjs';
import { SnackbarService } from '@markant-platform/shared/snackbar/feature';
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { MarkantElementsModule } from '@markant/elements-angular';
import { TranslocoModule } from '@jsverse/transloco';
import { ModalBridgeComponent } from '@markant-platform/shared/ui-modal';
import { ErrorMessage } from '@markant-platform/shared/error-model';

@Component({
  selector: 'markant-platform-group-delete-dialog',
  standalone: true,
  imports: [CommonModule, MarkantElementsModule, TranslocoModule, ModalBridgeComponent],
  templateUrl: './group-delete-dialog.component.html',
  styleUrls: ['./group-delete-dialog.component.scss'],
})
export class GroupDeleteDialogComponent {
  @Input({ required: true }) groupId!: string;

  constructor(
    private authorizerService: AuthorizerService,
    private snackBarService: SnackbarService,
    private router: Router
  ) {}

  isOpen = false;
  isLoading = false;

  async onDelete(): Promise<void> {
    this.isLoading = true;
    try {
      await firstValueFrom(this.authorizerService.deleteGroup(this.groupId));
      await this.router.navigate(['/organization', 'group-assignment']);

      this.isLoading = false;
      this.isOpen = false;
      this.snackBarService.showSuccessSnackbarWithTransloco(
        'dashboardOverview.groupAssignment.deleteDialog.successMessage'
      );
    } catch (e) {
      const httpErrorResponse: HttpErrorResponse = e as HttpErrorResponse;

      this.isLoading = false;
      this.isOpen = false;

      switch (httpErrorResponse.error?.message) {
        case ErrorMessage.CANNOT_REVOKE_OWN_ROLE:
          this.snackBarService.showErrorSnackbarWithTransloco('error.revokeOwnRole.deleteGroup');
          break;
        case ErrorMessage.DELETE_LAST_ORGANIZATION_ADMIN:
          this.snackBarService.showErrorSnackbarWithTransloco('error.lastOrgaAdmin.deleteGroup');
          break;
        default:
          this.snackBarService.showErrorSnackbarWithTransloco('error.common');
      }

      throw e;
    }
  }
}
